import { api } from '../../core/network/api';

/**
 * Emotes — a RADIO CALLOUT, not a dance: a voice line played on demand, never a wire payload
 * (same "meta layer only" posture as a player card). `EmotesController`'s three routes.
 * Equip is global, same shape as a charm.
 */
export interface EmoteEntry {
  id: number;
  name: string;
  description: string;
  /** The callout's own words, shown as the tile's subtitle in quotes. */
  line: string;
  /** Voice-line asset key — the file is `/game/audio/vo/emote-<voice>.ogg`. */
  voice: string;
  priceCoins: number;
  currency: 'PREMIUM';
  owned: boolean;
  equipped: boolean;
  affordable: boolean;
}

export interface EmoteCatalogueView {
  equippedEmote: number;
  emotes: EmoteEntry[];
}

/** `GET /emotes`. */
export const fetchEmotesCatalogue = () => api.get<EmoteCatalogueView>('/emotes');

/** `POST /emotes/purchase`. */
export const purchaseEmote = (emote: number) => api.post<{ equippedEmote: number }>('/emotes/purchase', { emote });

/** `POST /emotes/equip` — `emote: 0` takes it off; always a legal value. */
export const equipEmote = (emote: number) => api.post<{ equippedEmote: number }>('/emotes/equip', { emote });

/** Best-effort voice-line preview. The asset may 404 until the audio pipeline ships it — a
 * broken preview must never throw or surface an error, so every failure path is swallowed. */
export function previewEmoteVoice(voice: string): void {
  try {
    const audio = new Audio(`/game/audio/vo/emote-${voice}.ogg`);
    void audio.play().catch(() => {});
  } catch {
    // No Audio() in this environment (jsdom, ancient browser) — silently do nothing.
  }
}
